import {
  Anchor,
  Box,
  Button,
  Flex,
  Paper,
  Stack,
  Title,
  Text,
  Loader,
  Affix,
} from "@mantine/core";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
// import BankIDLogo from "../../../assets/bank-id-logo.svg";
import QRCode from "react-qr-code";
import { useUpdateCustomerPOAData } from "../../../hooks/ui/customerPOADataStore";
import {
  useStartSignUp,
  useStartSignIn,
  useStartLogin,
  useGetLoginStatus,
} from "../../../hooks/api/";
import { usePOAStepsStore } from "../../../hooks/ui/poaStepsDataStore";
import { useMediaQuery } from "@mantine/hooks";

export const Identify = ({
  setUserCancelled,
}: {
  setUserCancelled: Dispatch<SetStateAction<boolean>>;
}) => {
  const { nextStep } = usePOAStepsStore();
  const [complete, setComplete] = useState(false);

  const isMobile = useMediaQuery("(max-width: 56.25em)");

  const {
    customerPOAData: { personalNumber, transactionId },
    updatePersonalNumber,
    updateTransactionId,
    updateName,
    updateCredentials,
  } = useUpdateCustomerPOAData();
  const startLogin = useStartLogin();
  const signIn = useStartSignIn();
  const signUp = useStartSignUp();

  const getLoginStatus = useGetLoginStatus({
    id: startLogin.data?.body?.id,
    enabled: startLogin.isSuccess && !complete,
  });

  useEffect(() => {
    startLogin.mutate();
  }, []);

  useEffect(() => {
    if (getLoginStatus.data?.body?.status === "complete") {
      setComplete(true);
      const pn =
        getLoginStatus.data?.body?.providerInfo?.seBankID?.completionData?.user
          ?.personalNumber;
      const tid = getLoginStatus.data?.body?.id;
      const firstName =
        getLoginStatus.data?.body?.providerInfo?.seBankID?.completionData?.user
          ?.givenName;

      const lastName =
        getLoginStatus.data?.body?.providerInfo?.seBankID?.completionData?.user
          ?.surname;
      updateName(firstName, lastName);
      updatePersonalNumber(pn);
      updateTransactionId(tid);
      signIn.mutate({ personalNumber: pn, transactionId: tid });
    }
  }, [getLoginStatus.data?.body]);

  useEffect(() => {
    if (signIn.data?.isCustomer === false) {
      signUp.mutate({ personalNumber, transactionId });
    }
    if (signIn.isSuccess && signIn.data.credentials) {
      updateCredentials(signIn.data.credentials);
      nextStep();
    }
  }, [signIn.isSuccess, signIn.isError]);

  useEffect(() => {
    if (signUp.isSuccess) {
      updateCredentials(signUp.data.credentials);
      nextStep();
    }
  }, [signUp.isSuccess]);

  useEffect(() => {
    if (
      isMobile &&
      getLoginStatus.data?.body?.providerInfo?.seBankID?.autoStartToken
    ) {
      window.location.assign(
        `bankid:///?autostarttoken=${getLoginStatus.data?.body?.providerInfo?.seBankID?.autoStartToken}&redirect=null`
      );
    }
  }, [
    getLoginStatus.data?.body?.providerInfo?.seBankID?.autoStartToken,
    isMobile,
  ]);

  return (
    <Flex justify={"center"} pt={"xl"} mx={"lg"}>
      <Stack p={"lg"} maw={"770px"} w={"100%"}>
        <Title
          order={2}
          ff={"var(--wallet-font-family-subjecttivity)"}
          mb={"md"}
        >
          Var vänlig legitimera dig med BankID
        </Title>
        <Paper p={30} radius={"24px"} mb={"2rem"}>
          <Flex align="center" justify={"space-between"} mb={"xl"}>
            <Box>
              <Title order={5} mb="md">
                Gör såhär:
              </Title>
              <Text pr={"xl"}>
                Starta BankID-appen på mobila enhet och tryck på “Skanna
                QR-kod”. Rikta kameran mot QR-koden och signera.
              </Text>
            </Box>
            <Box>
              {getLoginStatus.isLoading || (startLogin.isPending && <Loader />)}
              {getLoginStatus.isSuccess &&
                !startLogin.isPending &&
                !isMobile && (
                  <QRCode
                    value={
                      getLoginStatus.data.body.providerInfo.seBankID.qrData
                    }
                  />
                )}
            </Box>
          </Flex>

          {getLoginStatus.isSuccess &&
            !getLoginStatus.isLoading &&
            !startLogin.isPending && (
              <Text ta="center" mb={"xl"}>
                Har du inte Mobil BankID?{" "}
                <Anchor
                  href={`bankid:///?autostarttoken=${getLoginStatus.data?.body?.providerInfo?.seBankID?.autoStartToken}&redirect=null`}
                >
                  Använd BankID på samma enhet
                </Anchor>
              </Text>
            )}

          <Affix position={{ bottom: 0 }} bg={"white"} w={"100vw"} p={"lg"}>
            <Flex justify={"center"}>
              <Button variant="outline" onClick={() => setUserCancelled(true)}>
                Cancel
              </Button>
            </Flex>
          </Affix>
        </Paper>
      </Stack>
    </Flex>
  );
};
